module.exports = __webpack_public_path__ + "static/media/Spanish V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL.060180fa.jpg";